// Utility class to format display values between a range
export const formatMinMaxDisplayValues = (
  /** The minimum value if used */
  minLabel?: string,
  /** The maximum value if used */
  maxLabel?: string,
  /** The fallback display if neither max nor min labels are used */
  defaultLabel?: string,
  /**
   * For when both max & min labels are defined, whether or not to remove any suffixes
   * e.g. (750 sq ft - 1000 sq ft) -> (750 - 1000 sq ft)
   **/
  suffixRemovalStr = ''
) => {
  if (!!minLabel && !!maxLabel) {
    return `${minLabel.replace(suffixRemovalStr, '').trim()} - ${maxLabel}`
  }

  if (maxLabel) {
    return `<${maxLabel}`
  }

  if (minLabel) {
    return `${minLabel}+`
  }

  return defaultLabel
}
